<h1 mat-dialog-title>{{error}}</h1>
<mat-dialog-content>
	<p>{{errorDetail}}</p>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
	<button [color]="'accent'" mat-dialog-close mat-raised-button>
		<span>{{'errorModal.closeButton' | translate}}</span>
	</button>
</mat-dialog-actions>
